import { palette, paletteDark } from './palette';
var getPalette = function (themeType) {
    /**
     * When running unit tests, always return the direct palette.
     * This avoids needing to provide a theme provider on each render.
     */
    if (process.env.NODE_ENV === 'test') {
        return palette;
    }
    if (typeof themeType === 'string') {
        return themeType === 'light' ? palette : paletteDark;
    }
    return themeType.palette;
};
export var focusOutline = function (theme, options) {
    var _a, _b;
    var palette = getPalette(theme);
    var colorIn = (_a = options === null || options === void 0 ? void 0 : options.colorInside) !== null && _a !== void 0 ? _a : palette.focus.light;
    var colorOut = (_b = options === null || options === void 0 ? void 0 : options.colorOutside) !== null && _b !== void 0 ? _b : palette.focus.main;
    var offset = -1;
    if (options && typeof options.position === 'number') {
        offset = options.position;
    }
    else if (options && options.position === 'inset') {
        offset = 1;
    }
    return {
        '&::before': {
            content: '""',
            position: 'absolute',
            top: offset,
            left: offset,
            right: offset,
            bottom: offset,
            borderRadius: 'inherit',
            boxShadow: "0 0 0 1px ".concat(colorIn, ", 0 0 0 2px ").concat(colorOut, ", 0 0 0 3px ").concat(palette.background.default),
            // Needed for high contrast mode
            border: "2px solid ".concat(palette.highContrastOnly.main),
        },
    };
};
//# sourceMappingURL=mixins.js.map